"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("./components/ImportExcel/index.vue"));
var _kpiManagement = require("@/http/interface/sfe/kpiManagement");
var _index2 = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** utils */
var _default = exports.default = {
  components: {
    ImportExcel: _index.default
  },
  data: function data() {
    return {
      /** page common */
      pageName: 'contractKPIManagement',
      /** enum */
      optConfig: {},
      /** search group */
      searchVal: {
        rsmEmpNo: '',
        // RSM工号
        rsmEmpName: '',
        // RSM姓名
        asmEmpNo: '',
        // ASM工号
        asmEmpName: '',
        // ASM姓名
        empNo: '',
        // SR工号
        empName: '',
        // SR姓名
        year: '' // 年份
      },
      /** table group */
      table: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      /** others */
      loadingComponent: null,
      isLoading: false // export\upload 等使用
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.queryEnumOptions();
    this.searchData();
  },
  methods: {
    /**
     * 枚举
     */
    /** 格式化 枚举 */
    formatEnum: function formatEnum(key, from) {
      return (0, _index2.formatKeyValue)(key, this.optConfig[from]);
    },
    /** 获取计划类型 enum */queryEnumOptions: function queryEnumOptions() {
      // const ssbtype_key = 'STORE_SIGN_BRAND_TYPE' // 店招品牌
      // const param = {
      //   configItemCodeList: [ssbtype_key]
      // }
      // this.$api.common.getConfigItemByCode(param).then(res => {
      //   const data = res.data || {}
      //   // console.log(999, res)
      //   this.optConfig.ssbtypeOptions = data[ssbtype_key] || []
      // })
    },
    /**
     * search methods
     */
    // 搜索
    searchData: function searchData() {
      this.table.currPage = 1;
      this.fetchData();
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchVal = data.searchVal;
      this.searchData();
    },
    /**
     * table methods
     */
    // 获取 列表
    fetchData: function fetchData() {
      var _this = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel('cancel');
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.table.listLoading = true;
      (0, _kpiManagement.getMonthlySigningKpiList)(param, this.table.sourceApi.token).then(function (res) {
        var _ref = res.data || [],
          items = _ref.items,
          totalCount = _ref.totalCount;
        _this.table.list = items;
        _this.table.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this.table.listLoading = false;
      });
    },
    // 导出excel
    downloadExcel: function downloadExcel(name) {
      var _this2 = this;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _kpiManagement.exportMonthlySigningKpi)(param).then(function (res) {
        (0, _index2.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this2.isLoading = false;
      });
    }
  }
};